import { RouteObject } from 'react-router'
import pointsRoutes from './points/routes'
import rewardsRoutes from './rewards/routes'

const routes: RouteObject[] = [...pointsRoutes, ...rewardsRoutes]

export default routes
